<script>
  import conciliacaoProjetoServico from '../servico';
  import SelecaoBusca from './SelecaoBusca.vue';

  export const ORIGEM_EXTRATO = 'extrato';
  export const ORIGEM_CONTA_RECEBER = 'conta-receber';
  export const ORIGEM_EXTRATO_CONTA = 'extrato-conta';
  const ABA_BUSCA_CR = 'busca-cr';
  const ABA_CR_VINCULADOS = 'cr-vinculados';
  const LIMITE_BUSCA = 60;
  const filtroVazio = () => ({ historico: '', documento: '', notaFiscal: '' });

  export default {
    components: { SelecaoBusca },
    props: {
      idExtrato: { type: Number, default: 0 },
      idLancamento: { type: Number, default: 0 },
      comContasReceber: { type: Boolean, default: false },
      comBuscaContasReceber: { type: Boolean, default: false },
      comOutrosExtratos: { type: Boolean, default: false },
      idPessoa: { type: Number, default: 0 },
      nomePessoa: { type: String, default: '' },
      escolhidos: { type: Array, default: () => [] },
      idsContaReceber: { type: Array, default: () => [] },
    },
    data() {
      return {
        aba: ORIGEM_EXTRATO,
        extrato: { carregando: false, erro: '', dados: null, todos: false, semLinha: false, filtroNome: '' },
        outraConta: { id: 0, nome: '', carregando: false, erro: '', dados: null },
        contas: { carregando: false, erro: '', lista: null },
        vinculados: { carregando: false, erro: '', lista: null },
        busca: { filtro: filtroVazio(), carregando: false, erro: '', lista: null, termos: filtroVazio() },
        marcados: [],
        abrindo: '',
      }
    },
    computed: {
      temExtrato() { return this.idExtrato > 0 || this.idLancamento > 0; },
      mostraAbaExtrato() { return this.temExtrato || this.comOutrosExtratos; },
      idContaLinha() { return (this.extrato.dados && +this.extrato.dados.idConta) || 0; },
      naContaDaLinha() {
        return this.temExtrato && !!this.extrato.dados && (!this.outraConta.id || this.outraConta.id === this.idContaLinha);
      },
      extratoAtual() { return this.naContaDaLinha ? this.extrato.dados : this.outraConta.dados; },
      origemExtratoAtual() { return this.naContaDaLinha ? ORIGEM_EXTRATO : ORIGEM_EXTRATO_CONTA; },
      idOrigemExtrato() {
        if (this.naContaDaLinha) return this.extrato.dados.idExtrato;
        return (this.outraConta.dados && this.outraConta.dados.idConta) || 0;
      },
      carregandoExtrato() { return this.naContaDaLinha || !this.outraConta.id ? this.extrato.carregando : this.outraConta.carregando; },
      erroExtrato() { return this.naContaDaLinha || !this.outraConta.id ? this.extrato.erro : this.outraConta.erro; },
      arquivosDaConta() {
        const arquivos = (this.extratoAtual && this.extratoAtual.arquivos) || [];
        if (!this.naContaDaLinha || this.extrato.todos) return arquivos;
        return arquivos.filter(a => a.daLinha || a.doDia);
      },
      arquivosExtrato() {
        const termo = (this.extrato.filtroNome || '').trim().toLowerCase();
        if (!termo) return this.arquivosDaConta;
        return this.arquivosDaConta.filter(a => (a.nome || '').toLowerCase().indexOf(termo) >= 0);
      },
      totalExtrato() { return ((this.extratoAtual && this.extratoAtual.arquivos) || []).length; },
      ocultosExtrato() { return this.naContaDaLinha && !this.extrato.todos ? this.totalExtrato - this.arquivosDaConta.length : 0; },
      filtroExtratoAtivo() { return !!(this.extrato.filtroNome || '').trim() || (this.outraConta.id > 0 && !this.naContaDaLinha); },
      temVinculados() { return (this.idsContaReceber || []).some(id => +id > 0); },
      listaCr() {
        if (this.aba === ABA_BUSCA_CR) return this.busca.lista;
        if (this.aba === ABA_CR_VINCULADOS) return this.vinculados.lista;
        return this.contas.lista;
      },
      contasComArquivo() { return (this.listaCr || []).filter(c => (c.arquivos || []).length > 0); },
      contasSemArquivo() { return (this.listaCr || []).filter(c => !(c.arquivos || []).length); },
      temFiltroBusca() {
        const f = this.busca.filtro;
        return !!(f.historico.trim() || f.documento.trim() || f.notaFiscal.trim());
      },
      buscaNoLimite() { return (this.busca.lista || []).length >= LIMITE_BUSCA; },
      totalMarcados() { return this.marcados.length; },
    },
    mounted() {
      if (!this.temExtrato && !this.comOutrosExtratos) this.aba = this.comContasReceber ? ORIGEM_CONTA_RECEBER : ABA_BUSCA_CR;
      else if (!this.temExtrato && this.comContasReceber) this.aba = ORIGEM_CONTA_RECEBER;
      if (this.temVinculados) this.aba = ABA_CR_VINCULADOS;
      this.carregarAba();
    },
    methods: {
      trocarAba(aba) {
        this.aba = aba;
        this.carregarAba();
      },
      carregarAba() {
        if (this.aba === ORIGEM_EXTRATO) this.carregarExtrato();
        else if (this.aba === ORIGEM_CONTA_RECEBER) this.carregarContas();
        else if (this.aba === ABA_CR_VINCULADOS) this.carregarVinculados();
        else this.$nextTick(() => this.$refs.buscaHistorico && this.$refs.buscaHistorico.focus());
      },
      buscarContasExtrato(busca) { return conciliacaoProjetoServico.contasExtratoAnexo(busca); },
      escolherContaExtrato(opcao) {
        this.outraConta = { id: opcao ? opcao.id : 0, nome: opcao ? opcao.nome : '', carregando: false, erro: '', dados: null };
        if (!opcao || (this.temExtrato && opcao.id === this.idContaLinha)) return;

        this.outraConta.carregando = true;
        conciliacaoProjetoServico.extratoContaAnexo(opcao.id)
          .then(dados => {
            if (this.outraConta.id !== opcao.id) return;
            this.outraConta.carregando = false;
            this.outraConta.dados = dados || { arquivos: [] };
          })
          .catch(res => {
            if (this.outraConta.id !== opcao.id) return;
            this.outraConta.carregando = false;
            this.outraConta.erro = (res && res.body && res.body.message) || 'Não foi possível listar os extratos desta conta.';
          });
      },
      limparFiltroExtrato() {
        this.extrato.filtroNome = '';
        this.outraConta = { id: 0, nome: '', carregando: false, erro: '', dados: null };
      },
      buscarContas() {
        if (!this.temFiltroBusca || this.busca.carregando) return;

        const f = this.busca.filtro;
        this.busca.carregando = true;
        this.busca.erro = '';
        conciliacaoProjetoServico.buscarContasReceberAnexo({
          historico: f.historico.trim(),
          documento: f.documento.trim(),
          notaFiscal: f.notaFiscal.trim(),
        })
          .then(lista => {
            this.busca.carregando = false;
            this.busca.lista = lista || [];
            this.busca.termos = { historico: f.historico.trim(), documento: f.documento.trim(), notaFiscal: f.notaFiscal.trim() };
          })
          .catch(res => {
            this.busca.carregando = false;
            this.busca.erro = (res && res.body && res.body.message) || 'Não foi possível buscar os contas a receber.';
          });
      },
      limparBusca() {
        this.busca.filtro = filtroVazio();
        this.busca.termos = filtroVazio();
        this.busca.lista = null;
        this.busca.erro = '';
        this.$nextTick(() => this.$refs.buscaHistorico && this.$refs.buscaHistorico.focus());
      },
      carregarExtrato() {
        if (!this.temExtrato || this.extrato.dados || this.extrato.carregando) return;

        this.extrato.carregando = true;
        this.extrato.erro = '';
        conciliacaoProjetoServico.origemAnexoExtrato(this.idExtrato, this.idLancamento)
          .then(dados => {
            this.extrato.carregando = false;
            this.extrato.dados = dados || { arquivos: [] };
            this.extrato.semLinha = !dados;
            if (dados && !(dados.arquivos || []).some(a => a.daLinha || a.doDia)) this.extrato.todos = true;
          })
          .catch(res => {
            this.extrato.carregando = false;
            this.extrato.erro = (res && res.body && res.body.message) || 'Não foi possível listar os extratos da conta.';
          });
      },
      carregarVinculados() {
        if (!this.temVinculados || this.vinculados.lista || this.vinculados.carregando) return;

        this.vinculados.carregando = true;
        this.vinculados.erro = '';
        conciliacaoProjetoServico.origemAnexoContasReceberVinculados(this.idsContaReceber)
          .then(lista => {
            this.vinculados.carregando = false;
            this.vinculados.lista = lista || [];
          })
          .catch(res => {
            this.vinculados.carregando = false;
            this.vinculados.erro = (res && res.body && res.body.message) || 'Não foi possível listar os arquivos dos contas a receber vinculados.';
          });
      },
      carregarContas() {
        if (!(this.idPessoa > 0) || this.contas.lista || this.contas.carregando) return;

        this.contas.carregando = true;
        this.contas.erro = '';
        conciliacaoProjetoServico.origemAnexoContasReceber(this.idPessoa)
          .then(lista => {
            this.contas.carregando = false;
            this.contas.lista = lista || [];
          })
          .catch(res => {
            this.contas.carregando = false;
            this.contas.erro = (res && res.body && res.body.message) || 'Não foi possível listar os contas a receber do cliente.';
          });
      },
      chave(origem, id, nome) { return origem + '|' + id + '|' + (nome || '').toLowerCase(); },
      jaAnexado(origem, id, nome) {
        const c = this.chave(origem, id, nome);
        return this.escolhidos.some(e => e && e.referencia && this.chave(e.origem, e.id, e.nome) === c);
      },
      marcado(origem, id, nome) {
        const c = this.chave(origem, id, nome);
        return this.marcados.some(m => this.chave(m.origem, m.id, m.nome) === c);
      },
      alternar(origem, id, nome, rotulo) {
        if (this.jaAnexado(origem, id, nome)) return;

        const c = this.chave(origem, id, nome);
        const indice = this.marcados.findIndex(m => this.chave(m.origem, m.id, m.nome) === c);

        if (indice >= 0) this.marcados.splice(indice, 1);
        else this.marcados.push({ origem, id, nome, rotulo });
      },
      alternarConta(conta) {
        const livres = conta.arquivos.filter(n => !this.jaAnexado(ORIGEM_CONTA_RECEBER, conta.idLancamento, n));
        const todos = livres.every(n => this.marcado(ORIGEM_CONTA_RECEBER, conta.idLancamento, n));

        livres.forEach(n => {
          if (todos === this.marcado(ORIGEM_CONTA_RECEBER, conta.idLancamento, n))
            this.alternar(ORIGEM_CONTA_RECEBER, conta.idLancamento, n, this.rotuloConta(conta));
        });
      },
      contaToda(conta) {
        const livres = conta.arquivos.filter(n => !this.jaAnexado(ORIGEM_CONTA_RECEBER, conta.idLancamento, n));
        return livres.length > 0 && livres.every(n => this.marcado(ORIGEM_CONTA_RECEBER, conta.idLancamento, n));
      },
      rotuloExtrato() {
        const d = this.extratoAtual || {};
        return 'Extrato' + (d.nomeConta ? ' · ' + d.nomeConta : '');
      },
      escaparHtml(t) {
        return (t || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      },
      grifar(texto, campo) {
        const valor = this.escaparHtml(texto);
        let termo = this.aba === 'busca-cr' ? (this.busca.termos[campo] || '') : '';
        if (campo === 'notaFiscal') termo = termo.replace(/\D/g, '').replace(/^0+/, '');
        if (!termo) return valor;
        const re = new RegExp('(' + this.escaparHtml(termo).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
        return valor.replace(re, '<mark class="aol-grifo">$1</mark>');
      },
      rotuloConta(conta) { return 'CR ' + conta.idLancamento + (conta.documento ? ' · ' + conta.documento : ''); },
      nomeCurto(nome) { return (nome || '').split('/').pop(); },
      pasta(nome) {
        const partes = (nome || '').split('/');
        return partes.length > 1 ? partes.slice(0, -1).join('/') : '';
      },
      moeda(v) {
        return (+v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      visualizar(origem, id, nome) {
        this.abrindo = this.chave(origem, id, nome);
        conciliacaoProjetoServico.arquivoOrigemAnexo(origem, id, nome)
          .then(blob => {
            this.abrindo = '';
            const tipo = (blob && blob.type) || '';
            const visualizavel = tipo === 'application/pdf' || /^image\/(png|jpeg|gif|bmp)$/.test(tipo);
            const url = URL.createObjectURL(visualizavel ? blob : new Blob([blob], { type: 'application/octet-stream' }));

            if (visualizavel) {
              window.open(url, '_blank');
              return;
            }

            const link = document.createElement('a');
            link.href = url;
            link.download = this.nomeCurto(nome);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => URL.revokeObjectURL(url), 10000);
          })
          .catch(() => {
            this.abrindo = '';
            toastr.error('Não foi possível abrir o arquivo ' + this.nomeCurto(nome) + '.');
          });
      },
      confirmar() {
        this.$emit('escolher', this.marcados.map(m => ({
          referencia: true,
          origem: m.origem,
          id: m.id,
          nome: m.nome,
          name: this.nomeCurto(m.nome),
          rotulo: m.rotulo,
        })));
      },
    },
    template: `
      <div class="aol-back">
        <div class="aol-modal">
          <div class="aol-cab">
            <h4><i class="fa fa-folder-open-o"></i> Arquivos de outros locais</h4>
            <small>Marque os arquivos que já estão no sistema. Eles são copiados para este registro quando a operação for gravada.</small>
          </div>

          <div class="aol-barra">
            <button v-if="temVinculados" type="button" class="aol-aba" :class="{ ativo: aba === 'cr-vinculados' }" @click="trocarAba('cr-vinculados')"
                    title="Contas a receber que você vinculou nesta regularização — costumam ter a nota fiscal">
              <i class="fa fa-link"></i> CR vinculados ({{ idsContaReceber.length }})
            </button>
            <button v-if="mostraAbaExtrato" type="button" class="aol-aba" :class="{ ativo: aba === 'extrato' }" @click="trocarAba('extrato')">
              <i class="fa fa-university"></i> Extrato da conta
            </button>
            <button v-if="comContasReceber" type="button" class="aol-aba" :class="{ ativo: aba === 'conta-receber' }" @click="trocarAba('conta-receber')">
              <i class="fa fa-file-text-o"></i> Contas a receber do cliente
            </button>
            <button v-if="comBuscaContasReceber" type="button" class="aol-aba" :class="{ ativo: aba === 'busca-cr' }" @click="trocarAba('busca-cr')">
              <i class="fa fa-search"></i> Buscar contas a receber
            </button>
          </div>
          <div class="aol-ajuda" v-if="aba === 'extrato'">
            <template v-if="naContaDaLinha">O arquivo de onde veio a linha aparece primeiro, seguido dos outros do mesmo dia. Para puxar outros extratos, veja todos os da conta ou escolha outra conta.</template>
            <template v-else>Escolha a conta e, se quiser, filtre pelo nome do arquivo (a data costuma estar nele).</template>
          </div>

          <div v-if="aba === 'extrato' && comOutrosExtratos" class="aol-filtros">
            <div class="aol-filtro aol-filtro-lg">
              <label>Conta</label>
              <selecao-busca :value="outraConta.id || idContaLinha" :texto="outraConta.nome || (extrato.dados && extrato.dados.nomeConta) || ''"
                             :buscar="buscarContasExtrato" placeholder="Nome ou número da conta..." @selecionado="escolherContaExtrato"></selecao-busca>
            </div>
            <div class="aol-filtro">
              <label>Nome do arquivo</label>
              <input type="text" class="form-control" v-model="extrato.filtroNome" maxlength="60" placeholder="Ex.: 28092026 ou 7269">
            </div>
            <div class="aol-filtro-botoes">
              <button type="button" class="btn btn-default no-margins" :disabled="!filtroExtratoAtivo" @click="limparFiltroExtrato">
                <i class="fa fa-eraser"></i> Limpar filtros
              </button>
            </div>
            <div v-if="naContaDaLinha" class="aol-escopo">
              <button type="button" :class="{ ativo: !extrato.todos }" @click="extrato.todos = false">Da linha e do mesmo dia</button>
              <button type="button" :class="{ ativo: extrato.todos }" @click="extrato.todos = true">Todos da conta ({{ totalExtrato }})</button>
            </div>
          </div>
          <div class="aol-ajuda" v-else-if="aba === 'cr-vinculados'">Contas a receber que você vinculou nesta regularização, com os arquivos do título e da nota fiscal. Marque os que quer copiar.</div>
          <div class="aol-ajuda" v-else-if="aba === 'conta-receber'">Contas a receber em aberto de <b>{{ nomePessoa || 'cliente escolhido' }}</b>. Marque um ou mais arquivos de cada título.</div>
          <div class="aol-ajuda" v-else>Busque contas a receber em aberto pelo histórico, pelo documento ou pelo número da nota fiscal.</div>

          <form v-if="aba === 'busca-cr'" class="aol-filtros" @submit.prevent="buscarContas">
            <div class="aol-filtro aol-filtro-lg">
              <label>Histórico</label>
              <input ref="buscaHistorico" type="text" class="form-control" v-model="busca.filtro.historico" maxlength="100" placeholder="Parte do histórico ou complemento">
            </div>
            <div class="aol-filtro">
              <label>Documento</label>
              <input type="text" class="form-control" v-model="busca.filtro.documento" maxlength="50" placeholder="Documento do título">
            </div>
            <div class="aol-filtro aol-filtro-sm">
              <label>Nota fiscal</label>
              <input type="text" class="form-control" v-model="busca.filtro.notaFiscal" maxlength="20" placeholder="Número da NF">
            </div>
            <div class="aol-filtro-botoes">
              <button type="submit" class="btn btn-success no-margins" :disabled="!temFiltroBusca || busca.carregando">
                <i class="fa" :class="busca.carregando ? 'fa-spinner fa-pulse' : 'fa-search'"></i> Buscar
              </button>
              <button type="button" class="btn btn-default no-margins" @click="limparBusca">
                <i class="fa fa-eraser"></i> Limpar filtros
              </button>
            </div>
          </form>

          <div class="aol-corpo">
            <template v-if="aba === 'extrato'">
              <div v-if="carregandoExtrato" class="aol-vazio"><i class="fa fa-spinner fa-pulse"></i> Buscando os extratos da conta...</div>
              <div v-else-if="erroExtrato" class="aol-vazio aol-erro">{{ erroExtrato }}</div>
              <div v-else-if="!extratoAtual" class="aol-inicio">
                <i class="fa fa-university"></i>
                <b>{{ temExtrato && extrato.semLinha ? 'Nenhuma linha de extrato ligada a este lançamento' : 'Nenhuma conta escolhida' }}</b>
                <span>Escolha a conta acima para ver os extratos dela.</span>
              </div>
              <template v-else>
                <div class="aol-resumo">
                  <span><i class="fa fa-university"></i> {{ extratoAtual.nomeConta }}</span>
                  <span v-if="naContaDaLinha && extratoAtual.dataMovimento"><i class="fa fa-calendar"></i> {{ extratoAtual.dataMovimento }}</span>
                  <span v-if="!naContaDaLinha" class="aol-tag aol-tag-cons">Outra conta</span>
                </div>

                <div v-if="!arquivosExtrato.length" class="aol-vazio">
                  {{ extrato.filtroNome.trim() ? 'Nenhum arquivo com esse nome.' : 'Nenhum arquivo de extrato na pasta desta conta.' }}
                </div>

                <ul v-else class="aol-lista">
                  <li v-for="a in arquivosExtrato" :key="a.nome"
                      :class="{ on: marcado(origemExtratoAtual, idOrigemExtrato, a.nome), bloq: jaAnexado(origemExtratoAtual, idOrigemExtrato, a.nome) }"
                      @click="alternar(origemExtratoAtual, idOrigemExtrato, a.nome, rotuloExtrato())">
                    <input type="checkbox" :checked="marcado(origemExtratoAtual, idOrigemExtrato, a.nome) || jaAnexado(origemExtratoAtual, idOrigemExtrato, a.nome)"
                           :disabled="jaAnexado(origemExtratoAtual, idOrigemExtrato, a.nome)" @click.stop="alternar(origemExtratoAtual, idOrigemExtrato, a.nome, rotuloExtrato())">
                    <i class="fa fa-file-pdf-o"></i>
                    <span class="aol-nome" :title="a.nome">
                      {{ nomeCurto(a.nome) }}
                      <small v-if="pasta(a.nome)">{{ pasta(a.nome) }}</small>
                    </span>
                    <span v-if="a.daLinha" class="aol-tag aol-tag-linha">Origem da linha</span>
                    <span v-else-if="a.doDia" class="aol-tag">Mesmo dia</span>
                    <span v-if="a.consolidado" class="aol-tag aol-tag-cons">Consolidado</span>
                    <span v-if="jaAnexado(origemExtratoAtual, idOrigemExtrato, a.nome)" class="aol-tag">Já escolhido</span>
                    <button type="button" class="aol-ver" title="Visualizar" @click.stop="visualizar(origemExtratoAtual, idOrigemExtrato, a.nome)">
                      <i class="fa" :class="abrindo === chave(origemExtratoAtual, idOrigemExtrato, a.nome) ? 'fa-spinner fa-pulse' : 'fa-eye'"></i>
                    </button>
                  </li>
                </ul>

                <button v-if="ocultosExtrato > 0" type="button" class="aol-mais-bloco" @click="extrato.todos = true">
                  <i class="fa fa-plus-circle"></i> Puxar os outros {{ ocultosExtrato }} extrato{{ ocultosExtrato > 1 ? 's' : '' }} desta conta
                </button>
              </template>
            </template>

            <template v-else>
              <template v-if="aba === 'busca-cr'">
                <div v-if="busca.carregando" class="aol-vazio"><i class="fa fa-spinner fa-pulse"></i> Buscando os contas a receber...</div>
                <div v-else-if="busca.erro" class="aol-vazio aol-erro">{{ busca.erro }}</div>
                <div v-else-if="!busca.lista" class="aol-inicio">
                  <i class="fa fa-search"></i>
                  <b>Nenhuma busca feita ainda</b>
                  <span>Preencha o histórico, o documento ou a nota fiscal (um só já basta) e clique em <b>Buscar</b>.<br>Só aparecem contas a receber em aberto dos projetos que você acessa.</span>
                </div>
                <div v-else-if="!busca.lista.length" class="aol-vazio">Nenhum contas a receber em aberto encontrado com esses filtros.</div>
                <div v-else-if="buscaNoLimite" class="aol-limite"><i class="fa fa-info-circle"></i> Mostrando os {{ busca.lista.length }} primeiros resultados. Refine os filtros para achar o título.</div>
              </template>
              <template v-else-if="aba === 'cr-vinculados'">
                <div v-if="vinculados.carregando" class="aol-vazio"><i class="fa fa-spinner fa-pulse"></i> Buscando os arquivos dos contas a receber vinculados...</div>
                <div v-else-if="vinculados.erro" class="aol-vazio aol-erro">{{ vinculados.erro }}</div>
                <div v-else-if="vinculados.lista && !vinculados.lista.length" class="aol-vazio">Os contas a receber vinculados não estão disponíveis para anexo.</div>
              </template>
              <template v-else>
                <div v-if="!(idPessoa > 0)" class="aol-vazio">Escolha o cliente para ver os contas a receber em aberto dele.</div>
                <div v-else-if="contas.carregando" class="aol-vazio"><i class="fa fa-spinner fa-pulse"></i> Buscando os contas a receber...</div>
                <div v-else-if="contas.erro" class="aol-vazio aol-erro">{{ contas.erro }}</div>
                <div v-else-if="contas.lista && !contas.lista.length" class="aol-vazio">Este cliente não tem contas a receber em aberto.</div>
              </template>
              <template v-if="listaCr && listaCr.length && !(aba === 'busca-cr' && busca.carregando)">
                <div v-for="c in contasComArquivo" :key="c.idLancamento" class="aol-cr">
                  <div class="aol-cr-cab">
                    <label class="aol-cr-todos" :title="'Marcar todos os arquivos do CR ' + c.idLancamento">
                      <input type="checkbox" :checked="contaToda(c)" @change="alternarConta(c)">
                    </label>
                    <div class="aol-cr-info">
                      <div class="aol-cr-l1">
                        <b>CR {{ c.idLancamento }}</b>
                        <span class="aol-cr-venc"><i class="fa fa-calendar"></i> {{ c.dataVencimentoStr }}</span>
                        <span class="aol-cr-valor mono">R$ {{ moeda(c.valor) }}</span>
                      </div>
                      <div class="aol-cr-l2">
                        <span v-if="aba === 'busca-cr' && c.nomeTerceiro"><i class="fa fa-user-o"></i> {{ c.nomeTerceiro }}</span>
                        <span v-if="c.nomeProjeto">{{ c.nomeProjeto }}</span>
                        <span v-if="c.nomeConta">{{ c.nomeConta }}</span>
                      </div>
                      <div class="aol-cr-campos">
                        <div class="aol-campo aol-campo-largo">
                          <span class="aol-campo-lbl">Histórico</span>
                          <span v-if="c.historico" class="aol-campo-val" :title="c.historico" v-html="grifar(c.historico, 'historico')"></span>
                          <span v-else class="aol-campo-val aol-campo-vazio">—</span>
                        </div>
                        <div v-if="c.complemento" class="aol-campo aol-campo-largo">
                          <span class="aol-campo-lbl">Complemento</span>
                          <span class="aol-campo-val" :title="c.complemento" v-html="grifar(c.complemento, 'historico')"></span>
                        </div>
                        <div class="aol-campo">
                          <span class="aol-campo-lbl">Documento</span>
                          <span v-if="c.documento" class="aol-campo-val mono" v-html="grifar(c.documento, 'documento')"></span>
                          <span v-else class="aol-campo-val aol-campo-vazio">—</span>
                        </div>
                        <div class="aol-campo">
                          <span class="aol-campo-lbl">Nota fiscal</span>
                          <span v-if="c.notaFiscal" class="aol-campo-val mono" v-html="grifar(c.notaFiscal, 'notaFiscal')"></span>
                          <span v-else class="aol-campo-val aol-campo-vazio">—</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ul class="aol-lista aol-lista-cr">
                    <li v-for="n in c.arquivos" :key="n"
                        :class="{ on: marcado('conta-receber', c.idLancamento, n), bloq: jaAnexado('conta-receber', c.idLancamento, n) }"
                        @click="alternar('conta-receber', c.idLancamento, n, rotuloConta(c))">
                      <input type="checkbox" :checked="marcado('conta-receber', c.idLancamento, n) || jaAnexado('conta-receber', c.idLancamento, n)"
                             :disabled="jaAnexado('conta-receber', c.idLancamento, n)" @click.stop="alternar('conta-receber', c.idLancamento, n, rotuloConta(c))">
                      <i class="fa fa-file-o"></i>
                      <span class="aol-nome" :title="n">{{ n }}</span>
                      <span v-if="(c.arquivosNotaFiscal || []).indexOf(n) >= 0" class="aol-tag aol-tag-cons" :title="'Arquivo da nota fiscal ' + (c.notaFiscal || '')">Da NF</span>
                      <span v-if="jaAnexado('conta-receber', c.idLancamento, n)" class="aol-tag">Já escolhido</span>
                      <button type="button" class="aol-ver" title="Visualizar" @click.stop="visualizar('conta-receber', c.idLancamento, n)">
                        <i class="fa" :class="abrindo === chave('conta-receber', c.idLancamento, n) ? 'fa-spinner fa-pulse' : 'fa-eye'"></i>
                      </button>
                    </li>
                  </ul>
                </div>

                <div v-if="contasSemArquivo.length" class="aol-sem">
                  <div class="aol-sem-tit"><i class="fa fa-exclamation-triangle"></i> {{ contasSemArquivo.length }} conta{{ contasSemArquivo.length > 1 ? 's' : '' }} a receber sem arquivo</div>
                  <div v-for="c in contasSemArquivo" :key="c.idLancamento" class="aol-sem-item">
                    <b>CR {{ c.idLancamento }}</b>
                    <span>{{ c.dataVencimentoStr }}</span>
                    <span class="mono">R$ {{ moeda(c.valor) }}</span>
                    <span v-if="c.documento" class="mono">Doc. <span v-html="grifar(c.documento, 'documento')"></span></span>
                    <span v-if="c.notaFiscal" class="mono" v-html="grifar(c.notaFiscal, 'notaFiscal')"></span>
                    <span v-if="c.historico || c.complemento" class="aol-sem-hist" :title="[c.historico, c.complemento].filter(Boolean).join(' · ')"
                          v-html="grifar([c.historico, c.complemento].filter(Boolean).join(' · '), 'historico')"></span>
                    <span class="aol-sem-aviso">Nenhum arquivo anexado a este título</span>
                  </div>
                </div>
              </template>
            </template>
          </div>

          <div class="aol-rodape">
            <span class="aol-cont" v-if="totalMarcados">{{ totalMarcados }} arquivo{{ totalMarcados > 1 ? 's' : '' }} marcado{{ totalMarcados > 1 ? 's' : '' }}</span>
            <button type="button" class="btn btn-default" @click="$emit('fechar')">Cancelar</button>
            <button type="button" class="btn btn-primary" :disabled="!totalMarcados" @click="confirmar">
              <i class="fa fa-paperclip"></i> Anexar {{ totalMarcados > 1 ? totalMarcados + ' arquivos' : 'arquivo' }}
            </button>
          </div>
        </div>
      </div>`,
  }
</script>

<style scoped>
  .aol-back { position: fixed; inset: 0; background: rgba(16,24,40,.5); z-index: 3400; display: flex; align-items: center; justify-content: center; padding: 20px; }
  .aol-modal { background: #fff; border-radius: 8px; box-shadow: 0 18px 48px rgba(16,24,40,.28); width: 100%; max-width: 780px; max-height: 88vh; display: flex; flex-direction: column; }
  .aol-cab { padding: 16px 20px 12px; border-bottom: 1px solid #e6eaee; flex: 0 0 auto; }
  .aol-cab h4 { margin: 0 0 3px; font-size: 17px; font-weight: 600; color: #1c2024; }
  .aol-cab small { color: #8a939c; font-size: 12.5px; }
  .aol-barra { display: flex; gap: 8px; padding: 10px 20px 0; flex: 0 0 auto; }
  .aol-aba { height: 32px; padding: 0 14px; border: 1px solid #d3d8de; border-radius: 6px; background: #fff; color: #4b545e; font-size: 12.5px; font-weight: 600; }
  .aol-aba:hover { background: #f4f6f8; }
  .aol-aba.ativo { background: #e8f5ef; border-color: #0f8a5f; color: #0a6d4d; }
  .aol-aba .fa { margin-right: 4px; }
  .aol-ajuda { padding: 7px 20px 10px; font-size: 12px; color: #6b747e; border-bottom: 1px solid #eef1f4; flex: 0 0 auto; }
  .aol-filtros { display: flex; flex-wrap: wrap; align-items: flex-end; gap: 10px; padding: 12px 20px; border-bottom: 1px solid #eef1f4; background: #fafbfc; flex: 0 0 auto; margin: 0; }
  .aol-filtro { display: flex; flex-direction: column; flex: 1 1 150px; min-width: 0; }
  .aol-filtro-lg { flex: 2 1 220px; }
  .aol-filtro-sm { flex: 0 1 120px; }
  .aol-filtro label { font-size: 11.5px; font-weight: 600; color: #4b545e; margin-bottom: 3px; }
  .aol-filtro .form-control { height: 32px; font-size: 12.5px; }
  .aol-filtro-botoes { display: flex; gap: 6px; flex: 0 0 auto; }
  .aol-filtro-botoes .btn { height: 34px; font-size: 13px; }
  .aol-escopo { display: flex; flex: 1 1 100%; border: 1px solid #d3d8de; border-radius: 6px; overflow: hidden; }
  .aol-escopo button { flex: 1; height: 30px; border: none; background: #fff; color: #4b545e; font-size: 12.5px; font-weight: 600; }
  .aol-escopo button + button { border-left: 1px solid #d3d8de; }
  .aol-escopo button.ativo { background: #e8f5ef; color: #0a6d4d; }
  .aol-mais-bloco { display: block; width: 100%; margin-top: 4px; padding: 9px; border: 1px dashed #b9c3cd; border-radius: 6px; background: #fafbfc; color: #2b6cb0; font-size: 12.5px; font-weight: 600; }
  .aol-mais-bloco:hover { background: #f1f5f9; border-color: #2b6cb0; }
  .aol-inicio { display: flex; flex-direction: column; align-items: center; gap: 6px; padding: 34px 16px; text-align: center; color: #6b747e; font-size: 12.5px; }
  .aol-inicio > .fa { font-size: 26px; color: #b7c0c9; }
  .aol-inicio > b { font-size: 13.5px; color: #3b444d; }
  .aol-limite { font-size: 12px; color: #8a5a00; background: #fffaf0; border: 1px solid #f0dfb8; border-radius: 5px; padding: 7px 10px; margin-bottom: 10px; }
  .aol-corpo { padding: 14px 20px; overflow: auto; flex: 1 1 auto; min-height: 180px; }
  .aol-vazio { padding: 28px 10px; text-align: center; color: #8a939c; font-size: 13px; }
  .aol-erro { color: #a13c3c; }
  .aol-resumo { display: flex; gap: 18px; flex-wrap: wrap; font-size: 12.5px; color: #4b545e; margin-bottom: 10px; }
  .aol-resumo .fa { color: #9aa3ac; margin-right: 3px; }
  .aol-lista { list-style: none; margin: 0; padding: 0; }
  .aol-lista li { display: flex; align-items: center; gap: 9px; padding: 7px 9px; border: 1px solid #e6e9ed; border-radius: 5px; margin-bottom: 6px; font-size: 12.5px; color: #3b444d; cursor: pointer; background: #fff; }
  .aol-lista li:hover { background: #f7f9fa; }
  .aol-lista li.on { border-color: #0f8a5f; background: #f1faf6; }
  .aol-lista li.bloq { cursor: default; opacity: .6; }
  .aol-lista input { margin: 0; flex: none; }
  .aol-lista .fa-file-pdf-o, .aol-lista .fa-file-o { color: #9aa3ac; flex: none; }
  .aol-nome { flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .aol-nome small { color: #9aa3ac; margin-left: 6px; font-size: 11px; }
  .aol-tag { flex: none; font-size: 10.5px; font-weight: 600; border-radius: 9px; padding: 2px 8px; background: #eef1f4; color: #5b6570; }
  .aol-tag-linha { background: #e3f3ec; color: #0a6d4d; }
  .aol-tag-cons { background: #fdf3e1; color: #8a5a00; }
  .aol-ver { flex: none; width: 26px; height: 26px; border: 1px solid #d3d8de; border-radius: 4px; background: #fff; color: #5b6570; }
  .aol-ver:hover { background: #eef1f4; }
  .aol-mais { margin-top: 4px; border: none; background: transparent; color: #2b6cb0; font-size: 12.5px; padding: 4px 0; }
  .aol-mais:hover { text-decoration: underline; }
  .aol-cr { border: 1px solid #e1e5ea; border-radius: 6px; padding: 10px 12px; margin-bottom: 10px; }
  .aol-cr-cab { display: flex; gap: 10px; align-items: flex-start; margin-bottom: 8px; }
  .aol-cr-todos { margin: 2px 0 0; cursor: pointer; }
  .aol-cr-todos input { margin: 0; }
  .aol-cr-info { flex: 1; min-width: 0; }
  .aol-cr-l1 { display: flex; gap: 12px; flex-wrap: wrap; align-items: baseline; font-size: 13px; color: #1c2024; }
  .aol-cr-venc { color: #6b747e; font-size: 12px; }
  .aol-cr-valor { margin-left: auto; font-weight: 600; }
  .aol-cr-l2 { display: flex; gap: 12px; flex-wrap: wrap; font-size: 11.5px; color: #8a939c; margin-top: 2px; }
  .aol-cr-l2 span { max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .aol-lista-cr li:last-child { margin-bottom: 0; }
  .aol-cr-campos { display: flex; flex-wrap: wrap; gap: 6px 18px; margin-top: 7px; padding: 7px 10px; background: #f7f9fa; border: 1px solid #edf0f3; border-radius: 5px; }
  .aol-campo { display: flex; flex-direction: column; min-width: 0; }
  .aol-campo-largo { flex: 1 1 100%; }
  .aol-campo-lbl { font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; color: #8a939c; }
  .aol-campo-val { font-size: 12.5px; color: #1c2024; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .aol-campo-vazio { color: #b3b9c0; }
  .aol-sem-hist { flex: 1 1 100%; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #3b444d; }
  .aol-cr >>> .aol-grifo, .aol-sem >>> .aol-grifo { background: #fde9a8; color: inherit; padding: 0 1px; border-radius: 2px; }
  .aol-sem { border: 1px dashed #e4cf9f; background: #fffaf0; border-radius: 6px; padding: 10px 12px; }
  .aol-sem-tit { font-size: 12px; font-weight: 600; color: #8a5a00; margin-bottom: 6px; }
  .aol-sem-item { display: flex; gap: 12px; flex-wrap: wrap; font-size: 12px; color: #5b6570; padding: 3px 0; }
  .aol-sem-aviso { color: #a0712a; font-style: italic; }
  .aol-rodape { display: flex; align-items: center; justify-content: flex-end; gap: 8px; padding: 12px 20px; border-top: 1px solid #e6eaee; flex: 0 0 auto; }
  .aol-cont { margin-right: auto; font-size: 12px; color: #0a6d4d; font-weight: 600; }
  .mono { font-family: 'IBM Plex Mono', Consolas, monospace; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/AnexosOutrosLocaisModal.vue